import React, {useCallback, useState} from 'react'
import {Form} from 'antd'

import useDidUpdate from 'utils/customHooks/useDidUpdate'
import {usersService} from 'services'
import requestHandler from 'utils/requestHandler'
import useUserContext from 'components/User/useUserContext'
import BButton from 'components/Form/Fields/BButton'
import SideSummary from 'modules/Checkout/SideSummary'
import DeliveryAddressBlock from 'modules/UserProfile/Settings/DeliveryAddressBlock'
import {DeliveryAddressFields} from 'modules/UserProfile/Settings/DeliveryAddress'
import {BillingInfoFields} from 'modules/UserProfile/Settings/BillingInfo'

const Checkout2 = ({t, next, back, billingInfo, setBillingInfo}) => {
  const {user, delivery, setDelivery} = useUserContext()

  const [form] = Form.useForm()

  const [deliveryAddresses, setDeliveryAddresses] = useState(user?.customerProfile?.deliveryAddresses ?? [])
  const [reloadNow, reload] = useState(1)

  useDidUpdate(() => {
    if (user) {
      setDeliveryAddresses(undefined)

      requestHandler(() => usersService.getCustomer(user.customerProfile.uuid), 'json')
        .then(r => {
          if (r.success) setDeliveryAddresses(r.data.deliveryAddresses)
          else setDeliveryAddresses(null)
        })
    } else {
      setDeliveryAddresses([])
    }
  }, [user, reloadNow])

  const nextWithSubmit = useCallback(() => {
    form.submit()
  }, [form])

  const onFinish = useCallback(({deliveryAddressSection, ...values}) => {
    if (deliveryAddressSection) setDelivery(deliveryAddressSection)
    setBillingInfo(values)

    next()
  }, [next, setBillingInfo, setDelivery])

  return (
    <div id='checkout2' className='checkout-basicLayout'>
      <h1>{t('Delivery & Billing information')}</h1>

      <div>
        <div>
          {deliveryAddresses.length > 0 && (
            <DeliveryAddressBlock
              t={t}
              deliveryAddresses={deliveryAddresses}
              reload={reload}
            />
          )}

          <Form form={form} onFinish={onFinish} initialValues={{deliveryAddressSection: {...delivery}, ...billingInfo}}>
            {deliveryAddresses.length === 0 && (
              <div className='formDesigned-block'>
                <h6>{t('Delivery addresses')}</h6>

                <DeliveryAddressFields t={t} root='deliveryAddressSection'/>
              </div>
            )}

            <div className='formDesigned-block'>
              <h6>{t('Biling information')}</h6>

              <BillingInfoFields t={t}/>
            </div>
          </Form>

          <BButton ghost onClick={back}>{t('back to summary')}</BButton>
          <BButton yellow onClick={nextWithSubmit}>{t('continue to')} <b>{t('payment')}</b></BButton>
        </div>

        <div>
          <SideSummary t={t}/>
        </div>
      </div>
    </div>
  )
}

export default Checkout2
